import { IIcon } from './iconConstants'
const WidgetIcon = (props: IIcon) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox='0 0 18 18'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g fill='none' fillRule='evenodd' opacity={props.opacity ? props.opacity : '.5'}>
        <path d='M-2-2h22v22H-2z' />
        <path
          d='M4.188.292a3.896 3.896 0 0 1 3.895 3.896v3.895H4.187a3.896 3.896 0 1 1 0-7.791zM6.25 6.25V4.187A2.062 2.062 0 1 0 4.187 6.25H6.25zM4.187 9.917h3.896v3.896a3.896 3.896 0 1 1-3.896-3.896zm0 1.833a2.062 2.062 0 1 0 2.063 2.063V11.75H4.187zM13.813.292a3.896 3.896 0 0 1 0 7.791H9.918V4.187A3.896 3.896 0 0 1 13.813.292zm0 5.958a2.062 2.062 0 1 0-2.062-2.063V6.25h2.063zM9.918 9.917h3.896a3.896 3.896 0 1 1-3.896 3.896V9.916zm1.833 1.833v2.063a2.062 2.062 0 1 0 2.063-2.063H11.75z'
          fill={props.fill}
          fillRule='nonzero'
        />
      </g>
    </svg>
  )
}
export default WidgetIcon
